import { render, staticRenderFns } from "./PaxUpdateItem.vue?vue&type=template&id=082551f4&scoped=true&"
import script from "./PaxUpdateItem.vue?vue&type=script&lang=js&"
export * from "./PaxUpdateItem.vue?vue&type=script&lang=js&"
import style0 from "./PaxUpdateItem.vue?vue&type=style&index=0&id=082551f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082551f4",
  null
  
)

export default component.exports